import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'antd';

import { subscribeReauth, startReauthPopup } from '../utils/reauth';

// Модалка переаутентификации: появляется при 401 (см. api/authFetch), по клику открывает
// попап с логином Keycloak. Клик нужен, т.к. попап без user gesture блокируется браузером.
const ReauthModal = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(
    () =>
      subscribeReauth((visible) => {
        setOpen(visible);
        if (!visible) {
          setLoading(false);
        }
      }),
    []
  );

  const onSignIn = () => {
    setLoading(true);
    // finally в startReauthPopup закроет модалку через subscribeReauth.
    startReauthPopup().catch(() => setLoading(false));
  };

  return (
    <Modal
      open={open}
      title="Sign in required"
      closable={false}
      maskClosable={false}
      keyboard={false}
      footer={null}
      centered
    >
      <p>Please sign in to continue.</p>
      <Button type="primary" loading={loading} onClick={onSignIn}>
        Sign in
      </Button>
    </Modal>
  );
};

export default ReauthModal;
